module.exports = __webpack_public_path__ + "images/花筑村全景_08-1.jpg?v=3e3c5d9c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_08-1.jpg
 ** module id = 100
 ** module chunks = 1 2
 **/